import { render } from "./StatPieChart.vue?vue&type=template&id=e9fdab46&scoped=true"
import script from "./StatPieChart.vue?vue&type=script&lang=js"
export * from "./StatPieChart.vue?vue&type=script&lang=js"

import "./StatPieChart.vue?vue&type=style&index=0&id=e9fdab46&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9fdab46"]])

export default __exports__